import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIntegration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="m9.863 4.571.472.434 1.283-1.394a.955.955 0 0 1 1.405 1.293L11.74 6.3l2.66 2.447 1.28-1.392a.959.959 0 1 1 1.411 1.298l-1.28 1.392.81.746a1.52 1.52 0 0 1-2.059 2.238l-.002-.002-1.23 1.337a2.14 2.14 0 0 1-3.027.126l-3.868-3.56a2.14 2.14 0 0 1-.126-3.027l1.259-1.368A1.521 1.521 0 0 1 9.863 4.57Zm-2.521 8.604a1 1 0 0 1 .06 1.413l-2.037 2.213a1 1 0 1 1-1.472-1.354l2.036-2.213a1 1 0 0 1 1.413-.059" />
  </svg>
);
export default SvgIntegration;
